
import { BaseModel } from "./base/base.model";

export class AppA3DocDocument extends BaseModel {
  code?: string;
  id?: string;
  title?: string;
  type?: string;
  size?: string;
  date?: string;
  dateModified?: string;
  customerId?: string;
  customerName?: string;
  isAppDoc?: string;
  containersId?: [];
  containersNames?: [];
  attributes?: [];
  docData?: string;
  viewedAt?: string;
}